import { membershipCollection } from 'app/src/msw/membership/initialSeed/membership'
import { apiBaseUrl } from 'app/src/msw/moneytransfer/api/apiBaseurl'
import { transfersCollection } from 'app/src/msw/moneytransfer/initialSeed/transfers'
import { creditCollection } from 'app/src/msw/shopping/initialSeed/credit'
import { transfersOrdersCollection } from 'app/src/msw/shopping/initialSeed/orders'
import { updateCredit } from 'app/src/msw/shopping/utils/updateCredit'
import type { moneytransferApi } from 'app/src/services/welfareportal'
import { HttpResponse } from 'msw'
import { http } from 'msw/core/http'

export const confirmTransfer = http.post<
  { transferId: string },
  moneytransferApi.TransferConfirm,
  moneytransferApi.TransferResponse | moneytransferApi.ErrorModel
>(apiBaseUrl + '/transfers/:transferId/confirm', async ({ params, request }) => {
  const bodyReq = await request.json()

  const activeMembership = JSON.parse(sessionStorage.getItem('selectedCampaign') || '{}')

  /* Preparing datas for transfer */
  const membershipData = await membershipCollection.findFirst()
  console.log('STEP 1 => check membership: ', membershipData ? 'OK' : 'KO')
  const transfer = await transfersCollection.findFirst((q) => q.where({ id: params.transferId }))
  console.log('STEP 2 => check refund: ', transfer ? 'OK' : 'KO')
  const transferOrder = await transfersOrdersCollection.findFirst((q) => q.where({ orderId: params.transferId }))
  console.log('STEP 3 => check refund order: ', transferOrder ? 'OK' : 'KO')
  const credit = await creditCollection.findFirst((q) => q.where({ membershipId: activeMembership?.membershipId }))
  console.log('STEP 4 => check credit: ', credit ? 'OK' : 'KO')

  const responseError: moneytransferApi.ErrorModel = {
    status: 404,
    title: 'Transfer order missing service category',
    type: 'urn:notfound',
  }

  if (transferOrder && transfer && credit) {
    /* preparing price details */
    const priceDetails = {
      grossPrice: bodyReq?.amount || transfer.amount || 0,
      netPrice: bodyReq?.amount || transfer.amount || 0,
      taxPercentage: 0,
      taxAmount: 0,
    }

    /* check sufficient credit */
    if (!transferOrder?.product?.serviceCategory) {
      console.error('Refund order is missing service category')
      console.log('########## MSW: END CONFIRM REFUND ##########')
      return HttpResponse.json(responseError, { status: 404 })
    }
    if (credit.creditByServiceCategory[transferOrder.product.serviceCategory] === undefined) {
      console.error('Credit is missing service category entry for', transferOrder.product.serviceCategory)
      console.log('########## MSW: END CONFIRM REFUND ##########')
      return HttpResponse.json(responseError, { status: 404 })
    }
    if ((credit.creditByServiceCategory[transferOrder.product.serviceCategory]?.available || 0) < priceDetails.grossPrice) {
      console.error('Insufficient credit for service category', transferOrder.product.serviceCategory)
      console.log('########## MSW: END CONFIRM REFUND ##########')
      return HttpResponse.json(responseError, { status: 404 })
    }

    /* update order status */
    const updatedOrder = await transfersOrdersCollection.update(transferOrder, {
      data(order) {
        order.status = 'confirmed' // TODO
        order.priceDetails = priceDetails
      },
    })
    /* update refund status */
    const updatedTransfer = await transfersCollection.update((q) => q.where({ id: params?.transferId as string }), {
      data(transfer) {
        transfer.status.value = 'SUBMITTED'
        transfer.status.updatedAt = new Date().toISOString()
        transfer.amount = bodyReq.amount || transfer.amount
        transfer.familyMembers = bodyReq.familyMembers || transfer.familyMembers
      },
    })

    try {
      await updateCredit(updatedOrder || transferOrder)
    } catch (error) {
      console.error('Error starting order:', error)
      return HttpResponse.json(responseError, { status: 404 })
    }

    return HttpResponse.json(updatedTransfer)
  } else {
    console.error('Error processing refund confirmation: missing data')
    console.log('########## MSW: END CONFIRM REFUND ##########')
    return HttpResponse.json(responseError, { status: 404 })
  }

  // const updatedOrder = transfersOrdersCollection.findFirst((q) => q.where({ orderId: params.transferId }))

  // const transferResponse: moneytransferApi.TransferResponse = {
  //   id: updatedOrder!.orderId,
  //   detailUrl: updatedOrder!.detailPageUrl,
  //   date: updatedOrder!.orderDate,
  //   productName: updatedOrder!.product.productName,
  //   productCode: updatedOrder!.product.productId,
  //   beneficiaryId: updatedOrder!.product.productId,
  //   kind: updatedOrder!.product.typology === 'moneyTransfer' ? 'FONDO_SANITARIO' : 'PREVIDENZA_COMPLEMENTARE',
  //   status: {
  //     value: 'SUBMITTED',
  //     updatedAt: new Date().toISOString(),
  //   },
  //   amount: bodyReq.amount ?? updatedOrder!.variant?.priceDetails?.facePrice,
  //   orderId: updatedOrder!.orderId,
  //   isCancellable: false,
  // }
})
